import React, { memo } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
export const InputCheckItems = memo((props) => {
    const { list, name, disabled, onChange } = props;
    return (React.createElement(React.Fragment, null, list.map((element, index) => {
        return (React.createElement(FormControlLabel, { key: index, control: React.createElement(Checkbox, { checked: element.value, onChange: (e) => onChange(index, element, e), name: `${name}${index}`, color: "primary" }), label: element.text, disabled: disabled }));
    })));
});
